import { render } from "./ReportFull.vue?vue&type=template&id=b0618ae6"
import script from "./ReportFull.vue?vue&type=script&lang=js"
export * from "./ReportFull.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__